import { Component, Input } from '@angular/core';

@Component({
  selector: 'gf-audio-modal',
  template: require('./audio-modal.component.html')
})
export class AudioModalComponent {

  @Input() file: any;
  @Input() close: any;

  constructor() { }
}
